import $ from "jquery";
export const scrollContent = {
    init: () => {
        scrollContent.enableGlobal();
        $("[data-scroll-content-target]").each(function () {
            const $thisElement = $(this);
            const scrollDirection = $thisElement.data("scroll-direction");
            const targetElementId = $thisElement.data("scroll-content-target");
            $thisElement.on("click", function () {
                switch (scrollDirection) {
                    case "left":
                        $("#" + targetElementId).animate({
                            scrollLeft: 0,
                        });
                        break;
                    default:
                        console.warn("Scroll content direction not supported");
                        break;
                }
            });
        });
    },
    enableGlobal: () => {
        if (!window["scrollContent"]) {
            window["scrollContent"] = scrollContent;
        }
    },
};
